import { Button } from "@gigpro/ui/Button";
import { Close, QwickAI } from "@gigpro/ui/Icons";
import { Popover, PopoverAnchor, PopoverContent } from "@gigpro/ui/Popover";
import { cn } from "@gigpro/ui/tailwind/cn";
import { useOnTakeover } from "domains/aiChat/hooks/useOnTakeover";
import { askQwickTooltipSeenAtom } from "domains/aiChat/lib/takeover";
import { useAtom } from "jotai";

/** agent-web-onboarding's Ask Qwick entry: quieter than the plain Ask Qwick pill, with a one-time first-visit tooltip. */
export const AskQwickPill = () => {
  const [seen, setSeen] = useAtom(askQwickTooltipSeenAtom);
  // The takeover is the agent, so its entry reads as open while it is on screen.
  const active = useOnTakeover();
  return (
    <Popover open={!seen}>
      <PopoverAnchor asChild>
        {/* The nav backdrop is black, so white/15 is the Marketplace switcher's grey. */}
        <span
          data-active={active || undefined}
          className={cn(
            "flex items-center gap-1.5 rounded-full py-1 pr-3 pl-1.5 text-white transition-colors",
            active ? "bg-brand-deep" : "bg-white/15 hover:bg-white/20",
          )}
        >
          <QwickAI className="size-4 shrink-0" />
          <span className="text-small font-semibold whitespace-nowrap">Ask Qwick</span>
        </span>
      </PopoverAnchor>
      <PopoverContent
        side="bottom"
        align="end"
        className="flex w-64 items-start gap-2 p-3"
        onOpenAutoFocus={(event) => event.preventDefault()}
        // Escape or a click elsewhere dismisses it for good, like its Close button; focus moving on does not.
        onEscapeKeyDown={() => setSeen(true)}
        onPointerDownOutside={() => setSeen(true)}
      >
        <div className="flex flex-col gap-0.5">
          <p className="font-semibold">Ask Qwick to post shifts and jobs</p>
          <p className="text-gray">Describe what you need and review the draft.</p>
        </div>
        <Button
          icon
          aria-label="Close"
          className="shrink-0 rounded-full p-1"
          onClick={(event) => {
            // The content is portalled, but React still bubbles the click to the nav button that opens the chat.
            event.stopPropagation();
            setSeen(true);
          }}
        >
          <Close className="size-3" />
        </Button>
      </PopoverContent>
    </Popover>
  );
};
